export default {
  SOFT_QUOTE: "6a5f0528-4720-11e9-bd01-0242ac140002",
  UNDERWRITING: "6a5f053c-4720-11e9-bd01-0242ac140002",
  INVESTMENT_COMMITTEE: "6a5f0551-4720-11e9-bd01-0242ac140002",
  BID_SUBMITTED: "6a5f0568-4720-11e9-bd01-0242ac140002",
  BEST_AND_FINAL: "6a5f0582-4720-11e9-bd01-0242ac140002",
  QUOTING: "6a5f059c-4720-11e9-bd01-0242ac140002",
  IN_CLOSING: "6a5f05b8-4720-11e9-bd01-0242ac140002",
  UNDER_REVIEW: "aa6997a2-1d51-11eb-9145-98fa9bde2f84",
  DUE_DILIGENCE: "b0601d4a-1d51-11eb-9145-98fa9bde2f84"
};
